import React, { useContext } from "react";
import styles from "./Footer.module.scss";
import PathContext from "../../context/path";
const Footer = () => {
  const path = useContext(PathContext);
  return (
    <>
      <footer className={styles.wrap}>
        <div className={styles.row}>
          <div className={styles.soc}>
            <a href="https://t.me/storylanding" target="_blank" rel="noopener noreferrer" className={styles.soc__link}>
              <img src={`${path}/img/soc-icon-tg.svg`} alt="" />
            </a>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}>
            <div className={styles.links}>
            <a href="https://www.infografika.agency/team" className={styles.link}><span>О нас</span></a>
              <a href="https://spb.hh.ru/employer/1417394" target="_blank" rel="noopener noreferrer" className={styles.link}><span>Вакансии</span></a>
              <a href="https://2.infografika.agency/privacy-policy/" target="_blank" rel="noopener noreferrer" className={styles.link}>
                <span>Политика конфиденциальности</span>
                <div className={styles.link__icon}>
                  <img src={`${path}/img/link-icon-2.svg`} alt="" />
                  <img src={`${path}/img/link-icon-2.svg`} alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className={styles.col}>
            <div className={styles.address}>
              <span>г. Санкт-Петербург,
              </span>
              <span>Б. Конюшенная ул., 19/8
              </span>
            </div>
          </div>
          <div className={styles.col}>
            <div className={styles.contact}>
              <a href="mailto:hello@infografika.agency">hello@infografika.agency</a>
              <a href="tel:+78127080060">+7 812 70 800 60</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );

}

export default Footer;
